<template>
  <div
    :class="
      billStatus == '0'
        ? 'ccui-app-box-iframe-operate-container'
        : 'ccui-app-iframe-no-operate-container'
    "
  >
    <template v-if="labelShow">
      <breadcrumbSourcing
        :breadcrumb-data="breadcrumbData"
      ></breadcrumbSourcing>
      <!--      <div class="detail-info-el-Label">-->
      <!--        <el-label :type="labelType" style="height: 100px;"></el-label>-->
      <!--      </div>-->
    </template>
    <div
      :class="
        billStatus == '0'
          ? 'ccui-app-iframe-container-detail'
          : 'ccui-app-iframe-container-no-operate-detail'
      "
    >
      <div class="ccui-app-iframe-container-detail-body">
        <!-- <div v-if="relationWarningList.length > 0" class="tips">
          <div style="color: red">温馨提示：</div>
          <div v-for="(item, index) in relationWarningList" :key="index">
            {{ item }}
          </div>
        </div> -->
        <el-tabs class="el-tabs__customize" value="1">
          <el-tab-pane
            :label="skillAndCommon ? '技术商务评分' : '商务评分'"
            name="1"
          >
            <template v-if="subPackageFlag">
              <el-tabs class="customeTab" v-model="active">
                <el-tab-pane
                  v-for="(listItem, listIndex) in transposedListData"
                  :key="listItem.packId"
                  :label="listItem.packName"
                  :name="listIndex + 1 + ''"
                >
                  <template v-if="labelType != 'ScoreComplete'">
                    <div class="customeTab-button-body">
                      <div class="fr customeTab-button">
                        <template v-if="listItem.hasScore">
                          <el-button
                            style="z-index: 1"
                            type="single-number"
                            plain
                            @click="addOrEdit(listItem, 1)"
                            >编辑</el-button
                          >
                        </template>
                        <template v-else>
                          <el-button
                            style="z-index: 1"
                            type="single-number"
                            plain
                            @click="addOrEdit(listItem, 0)"
                            >新增</el-button
                          >
                        </template>
                      </div>
                      <div class="clear"></div>
                    </div>
                  </template>
                  <!--<br />-->
                  <el-table
                    :data="listItem.list"
                    :span-method="data => objectSpanMethod(data, listIndex)"
                    border
                  >
                    <el-table-column
                      v-for="(item, index) in listItem.columns"
                      :key="index"
                      :show-overflow-tooltip="true"
                      v-bind="item"
                    >
                      <template
                        v-if="item.labelChild && item.labelChild.length > 0"
                      >
                        <el-table-column
                          v-for="(child, indexch) in item.labelChild"
                          :key="indexch"
                          align="center"
                          v-bind="child"
                        >
                          <template slot="header">
                            <div
                              class="el-tooltip tooltip-header"
                              :class="{
                                'tooltip-header-flow': child.label.length > 15
                              }"
                            >
                              {{ child.label }}
                            </div>
                          </template>
                          <template
                            v-if="
                              child.labelChild && child.labelChild.length > 0
                            "
                          >
                            <el-table-column
                              v-for="(childs, indexch) in child.labelChild"
                              :key="indexch"
                              align="center"
                              v-bind="child"
                            >
                              <template slot="header">
                                <el-button
                                  v-if="childs.label == '查看投标文件'"
                                  size="mini"
                                  type="text"
                                  @click="viewBidFile(childs)"
                                  >查看投标文件</el-button
                                >
                                <div
                                  v-else
                                  :title="childs.label"
                                  class="el-tooltip tooltip-header"
                                  :class="{
                                    'tooltip-header-flow':
                                      childs.label.length > 15
                                  }"
                                >
                                  {{ childs.label }}
                                </div>
                              </template>
                              <template
                                v-if="
                                  childs.labelChild &&
                                    childs.labelChild.length > 0
                                "
                              >
                                <el-table-column
                                  v-for="(childTwo,
                                  indexch) in childs.labelChild"
                                  :key="indexch"
                                  align="center"
                                  v-bind="childTwo"
                                >
                                  <template slot="header">
                                    <div
                                      class="el-tooltip tooltip-header"
                                      :class="{
                                        'tooltip-header-flow':
                                          childTwo.label.length > 15
                                      }"
                                    >
                                      {{ childTwo.label }}
                                    </div>
                                  </template>
                                  <template slot-scope="scope">
                                    <template v-if="scope.row.taskId">
                                      <el-button
                                        v-if="childTwo.type == 'ai'"
                                        size="mini"
                                        type="text"
                                        @click="
                                          toAI(scope.row, scope.column.property)
                                        "
                                        >{{
                                          scope.row[scope.column.property]
                                        }}</el-button
                                      >
                                      <el-button
                                        v-else-if="
                                          scope.row.pingshenxiangmu ==
                                            '汇总得分' &&
                                            scope.row[scope.column.property] !=
                                              '汇总得分'
                                        "
                                        size="mini"
                                        type="text"
                                        @click="
                                          toAI(scope.row, scope.column.property)
                                        "
                                        >{{
                                          scope.row[scope.column.property]
                                        }}</el-button
                                      >
                                      <span
                                        class="ellipsis-lines"
                                        :title="
                                          scope.row[scope.column.property]
                                        "
                                        v-else
                                        >{{
                                          scope.row[scope.column.property]
                                        }}</span
                                      >
                                    </template>
                                    <template v-else>
                                      <span
                                        class="ellipsis-lines"
                                        :title="
                                          scope.row[scope.column.property]
                                        "
                                        >{{
                                          scope.row[scope.column.property]
                                        }}</span
                                      >
                                    </template>
                                  </template>
                                </el-table-column>
                              </template>
                            </el-table-column>
                          </template>
                        </el-table-column>
                      </template>
                      <template slot-scope="scope">
                        <el-button
                          v-if="item.type == 'link'"
                          size="mini"
                          type="text"
                          @click="viewBidFile(scope.row)"
                          >查看投标文件</el-button
                        >
                        <span v-else-if="item.money">{{
                          scope.row[item.prop]
                            ? new BigNumber(scope.row[item.prop]).toFormat(2)
                            : ""
                        }}</span>
                        <span v-else>{{ scope.row[item.prop] }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
              </el-tabs>
            </template>
            <template v-else>
              <template v-for="(listItem, listIndex) in transposedListData">
                <div :key="listIndex">
                  <template v-if="labelType != 'ScoreComplete'">
                    <div class="fr">
                      <template v-if="listItem.hasScore">
                        <el-button
                          style="z-index: 1"
                          type="single-number"
                          plain
                          @click="addOrEdit(listItem, 1)"
                          >编辑</el-button
                        >
                      </template>
                      <template v-else>
                        <el-button
                          style="z-index: 1"
                          type="single-number"
                          plain
                          @click="addOrEdit(listItem, 0)"
                          >新增</el-button
                        >
                      </template>
                    </div>
                    <div class="clear"></div>
                  </template>
                  <!--<br />-->
                  <el-table
                    :data="listItem.list"
                    :span-method="data => objectSpanMethod(data, listIndex)"
                    border
                  >
                    <el-table-column
                      v-for="(item, index) in listItem.columns"
                      :key="index"
                      :show-overflow-tooltip="true"
                      v-bind="item"
                    >
                      <template
                        v-if="item.labelChild && item.labelChild.length > 0"
                      >
                        <el-table-column
                          v-for="(child, indexch) in item.labelChild"
                          :key="indexch"
                          align="center"
                          v-bind="child"
                        >
                          <template slot="header">
                            <div
                              :title="child.label"
                              class="el-tooltip tooltip-header"
                              :class="{
                                'tooltip-header-flow': child.label.length > 15
                              }"
                            >
                              {{ child.label }}
                            </div>
                          </template>
                          <template
                            v-if="
                              child.labelChild && child.labelChild.length > 0
                            "
                          >
                            <el-table-column
                              v-for="(childs, indexch) in child.labelChild"
                              :key="indexch"
                              align="center"
                              v-bind="child"
                            >
                              <template slot="header">
                                <el-button
                                  v-if="childs.label == '查看投标文件'"
                                  size="mini"
                                  type="text"
                                  @click="viewBidFile(childs)"
                                  >查看投标文件</el-button
                                >
                                <div
                                  v-else
                                  :title="childs.label"
                                  class="el-tooltip tooltip-header"
                                  :class="{
                                    'tooltip-header-flow':
                                      childs.label.length > 15
                                  }"
                                >
                                  {{ childs.label }}
                                </div>
                              </template>
                              <template
                                v-if="
                                  childs.labelChild &&
                                    childs.labelChild.length > 0
                                "
                              >
                                <el-table-column
                                  v-for="(childTwo,
                                  indexch) in childs.labelChild"
                                  :key="indexch"
                                  align="center"
                                  v-bind="childTwo"
                                >
                                  <template slot="header">
                                    <div
                                      :title="childTwo.label"
                                      class="el-tooltip tooltip-header"
                                      :class="{
                                        'tooltip-header-flow':
                                          childTwo.label.length > 15
                                      }"
                                    >
                                      {{ childTwo.label }}
                                    </div>
                                  </template>
                                  <template slot-scope="scope">
                                    <template v-if="scope.row.taskId">
                                      <el-button
                                        v-if="childTwo.type == 'ai'"
                                        size="mini"
                                        type="text"
                                        @click="
                                          toAI(scope.row, scope.column.property)
                                        "
                                        >{{
                                          scope.row[scope.column.property]
                                        }}</el-button
                                      >
                                      <el-button
                                        v-else-if="
                                          scope.row.pingshenxiangmu ==
                                            '汇总得分' &&
                                            scope.row[scope.column.property] !=
                                              '汇总得分'
                                        "
                                        size="mini"
                                        type="text"
                                        @click="
                                          toAI(scope.row, scope.column.property)
                                        "
                                        >{{
                                          scope.row[scope.column.property]
                                        }}</el-button
                                      >
                                      <span
                                        class="ellipsis-lines"
                                        :title="
                                          scope.row[scope.column.property]
                                        "
                                        v-else
                                        >{{
                                          scope.row[scope.column.property]
                                        }}</span
                                      >
                                    </template>
                                    <span
                                      class="ellipsis-lines"
                                      :title="scope.row[scope.column.property]"
                                      v-else
                                      >{{
                                        scope.row[scope.column.property]
                                      }}</span
                                    >
                                  </template>
                                </el-table-column>
                              </template>
                            </el-table-column>
                          </template>
                        </el-table-column>
                      </template>
                      <template slot-scope="scope">
                        <el-button
                          v-if="item.type == 'link'"
                          size="mini"
                          type="text"
                          @click="viewBidFile(scope.row)"
                          >查看投标文件</el-button
                        >
                        <span v-else-if="item.money">{{
                          scope.row[item.prop]
                            ? new BigNumber(scope.row[item.prop]).toFormat(2)
                            : ""
                        }}</span>
                        <span v-else>{{ scope.row[item.prop] }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </template>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <template v-if="billStatus == '0'">
      <div class="operate">
        <!--<el-button-->
        <!--v-if="labelType != 'ScoreComplete' && listData[active - 1].hasScore"-->
        <!--type="text"-->
        <!--icon="icon-ccui-edit"-->
        <!--v-preventReClick-->
        <!--@click="addOrEdit(listData[active - 1], 1)"-->
        <!--&gt;编辑</el-button-->
        <!--&gt;-->
        <!--<el-button-->
        <!--v-if="labelType != 'ScoreComplete' && !listData[active - 1].hasScore"-->
        <!--type="text"-->
        <!--icon="icon-ccui-edit"-->
        <!--v-preventReClick-->
        <!--@click="addOrEdit(listData[active - 1], 0)"-->
        <!--&gt;新增</el-button-->
        <!--&gt;-->
        <el-button
          type="text"
          icon="icon-ccui-save"
          v-preventReClick
          @click="dealExpertSupScoreSubmit"
          >提交</el-button
        >
      </div>
    </template>
    <el-dialog
      :visible.sync="dialogVisible"
      title="供应商投标详细信息"
      width="1200px"
      v-if="dialogVisible"
    >
      <supplierBidDetails
        :supQuoteId="formData.supQuoteId"
        :supPackQuoteId="formData.supPackQuoteId"
        :supCode="formData.supCode"
        source="default"
      ></supplierBidDetails>
      <div slot="footer">
        <el-button
          size="mini"
          type="default-mini"
          @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          size="mini"
          type="primary-font-mini"
          @click="dialogVisible = false"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogScore"
      class="chakanfen"
      width="100%"
      height="70vh"
    >
      <iframe
        :src="scoreUrl"
        frameborder="0"
        height="100%"
        width="100%"
      ></iframe>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="default-mini" @click="dialogScore = false"
          >关闭</el-button
        >
        <!--<el-button size="mini" type="primary-font-mini" @click="addRoleInfo()"-->
        <!--&gt;提交</el-button-->
        <!--&gt;-->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import BigNumber from "bignumber.js";
import supplierBidDetails from "@/app/sourcingFlow/views/supplierBidDetails.vue";
import breadcrumbSourcing from "@/app/sourcingFlow/components/breadcrumb-sourcing.vue";
import {
  qryExpertScorePackListApi,
  qryExpertSupPackQuoteToScoreApi,
  qryExpertSupPackQuoteScoreApi,
  dealExpertSupScoreSubmitApi,
  qryBidEvaProcessStatusApi,
  bidSupPersonnelRelationWarning
} from "@/app/sourcingFlow/api/expertEvaluation.js";
import bidEvaProcessStatus from "@/app/sourcingFlow/mixins/getBidEvaProcessStatus.js";
import { commonTableWidth } from "@/setting/setting.js";
export default {
  name: "commercialGradeList",
  components: {
    supplierBidDetails,
    breadcrumbSourcing
  },
  inject: ["reload"],
  mixins: [bidEvaProcessStatus],
  props: {
    skillAndCommon: {
      type: Boolean,
      default: false // false:商务评分  true:商务技术评分
    }
  },
  data() {
    return {
      BigNumber: BigNumber,
      breadcrumbData: {
        titname: this.$router.history.current.query.backPageSkillAndCommon
          ? this.$router.history.current.query.backPageSkillAndCommon == "1"
            ? "技术商务评分"
            : "商务评分"
          : this.skillAndCommon
          ? "技术商务评分"
          : "商务评分",
        status: JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
          .billStatusName
      },
      labelShow: false,
      labelType:
        JSON.parse(sessionStorage.getItem("bidEvaProcessStatus")).billStatus ===
        "0"
          ? "score"
          : "ScoreComplete", // 评分中：score 评分完成：ScoreComplete
      billStatus: JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
        .billStatus,
      dialogVisible: false,
      dialogScore: false,
      scoreUrl: "",
      listData: [],
      active: "1",
      headers: [],
      formData: {
        supPackQuoteId: "",
        supQuoteId: 0, // 供应商报价ID
        supCode: "" // 供应商编号
      },
      columns: [],
      columnsCopy: [
        {
          prop: "id",
          label: "序号",
          width: 55
        },
        {
          prop: "supName",
          label: "供应商",
          width: commonTableWidth.supplierName
        },
        {
          prop: "supTypeNewName",
          label: "供应商类型",
          align: "center",
          width: 100
        },
        {
          prop: "supLevelName",
          label: "供应商等级",
          align: "center",
          width: 100
        },
        {
          prop: "supCategoryName",
          label: "供应商分类",
          align: "center",
          width: 100
        },
        {
          prop: "priceAmount",
          label:
            "投标金额（" + sessionStorage.getItem("moneyTypeName") + "）含税",
          width: 170,
          money: true
        },
        {
          prop: "查看投标文件",
          label: "投标文件",
          width: 130,
          type: "link"
        },
        {
          prop: "sscScoreItemBOS",
          label: "商务",
          labelChild: [],
          align: "center"
        },
        {
          prop: "supScore",
          label: "汇总得分",
          width: 90,
          align: "center"
        },
        {
          prop: "scoreDesc",
          label: "打分说明",
          width: 180
        }
      ],
      subPackageFlag: false, // 是否分包 false:不分包
      purchaseType: 0,
      relationWarningList: []
    };
  },
  computed: {
    transposedListData() {
      let transposedListData = [];
      this.listData.forEach((tItem, i) => {
        //组装新数据
        let list = [];
        list.push();
        tItem.columns.forEach(item => {
          if (
            item.prop == "sscSkillScoreItemBOS" ||
            item.prop == "sscScoreItemBOS"
          ) {
            item.labelChild.forEach(aitem => {
              aitem.labelChild.forEach(bitem => {
                bitem.labelChild.forEach(citem => {
                  let obj = {};
                  obj.pingshenxiangmu = item.label;
                  obj.pingshenxize = aitem.label;
                  obj.xizequanzhong = bitem.label;
                  obj.pingshenbiaozhun = citem.label;
                  tItem.list.forEach(o => {
                    obj.supCode = o.supCode;
                    obj.scoringItemId = o.scoringItemId;
                    obj.originProp = citem.prop;
                    obj["supScore" + o.supCode] = o[citem.prop];
                    obj["aiScore" + o.supCode] = o[citem.prop + "aiScore"];
                    obj.taskId = o.taskId;
                  });
                  list.push(obj);
                });
              });
            });
          }
        });
        let explain = {
          pingshenxiangmu: "打分说明"
        };

        let o = { pingshenxiangmu: "汇总得分" };
        tItem.list.forEach(item => {
          o["supScore" + item.supCode] = item.supScore;
          o["aiScore" + item.supCode] = item.aiSumScore
            ? new BigNumber(item.aiSumScore).toFormat(2)
            : item.aiSumScore;
          o.taskId = item.taskId;
          explain["supScore" + item.supCode] = item.scoreDesc;
        });
        list.push(explain);
        list.push(o);
        transposedListData[i] = JSON.parse(JSON.stringify(tItem));
        transposedListData[i].list = list;

        //组装表头
        let arr = [
          {
            prop: "toubiaoxinxi",
            label: "投标信息",
            labelChild: [
              {
                prop: "toubiaojine",
                label:
                  "投标金额（" +
                  sessionStorage.getItem("moneyTypeName") +
                  "）含税",
                align: "center",
                labelChild: [
                  {
                    prop: "toubiaojine",
                    label: "投标文件",
                    align: "center",
                    labelChild: [
                      {
                        prop: "pingshenxiangmu",
                        label: "评审项目",
                        align: "center",
                        width: 100
                      },
                      {
                        prop: "pingshenxize",
                        label: "评审细则",
                        align: "center",
                        width: 100
                      },
                      {
                        prop: "xizequanzhong",
                        label: "细则权重",
                        align: "center",
                        width: 100
                      },
                      {
                        prop: "pingshenbiaozhun",
                        label: "评审标准",
                        align: "center",
                        width: 200
                      }
                    ]
                  }
                ]
              }
            ],
            align: "center"
          }
        ];
        tItem.list.forEach(item => {
          arr.push({
            prop: "gongyingshang" + item.supCode,
            label: item.supName,
            align: "center",
            labelChild: [
              {
                prop: "toubiaojineNum",
                label: item.priceAmount
                  ? new BigNumber(item.priceAmount).toFormat(2)
                  : "",
                align: "center",
                labelChild: [
                  {
                    prop: "chakan",
                    label: "查看投标文件",
                    align: "center",
                    supQuoteId: item.supQuoteId,
                    supPackQuoteId: item.supPackQuoteId,
                    supCode: item.supCode,
                    labelChild: item.taskId
                      ? [
                          {
                            prop: "supScore" + item.supCode,
                            label: "专家打分",
                            align: "center",
                            width: 100,
                            type: "input"
                          }
                          // {
                          //   prop: "aiScore" + item.supCode,
                          //   label: "AI打分",
                          //   align: "center",
                          //   type: "ai",
                          //   width: 100
                          // }
                        ]
                      : [
                          {
                            prop: "supScore" + item.supCode,
                            label: "专家打分",
                            align: "center",
                            width: 100,
                            type: "input"
                          }
                        ]
                  }
                ]
              }
            ]
          });
        });
        transposedListData[i].columns = arr;
      });
      console.log(transposedListData, "transposedListData00000000000");
      return transposedListData;
    }
  },
  created() {
    this.$route.query.active && (this.active = this.$route.query.active);
  },
  mounted() {
    let expertSourceData = JSON.parse(
      sessionStorage.getItem("expertSourceData")
    );
    this.purchaseType = expertSourceData.purchaseType;

    if (
      expertSourceData.purchaseType == "50" ||
      expertSourceData.purchaseType == "53"
    ) {
      this.columnsCopy.splice(5, 1);
      this.columns = this.columnsCopy;
    } else {
      this.columns = this.columnsCopy;
    }

    if (this.$router.history.current.query.backPageSkillAndCommon) {
      this.skillAndCommon =
        this.$router.history.current.query.backPageSkillAndCommon == "1"
          ? true
          : false;
    }
    this.getData();
    this.getSupPersonnelRelationWarning();
  },
  methods: {
    toAI(row, prop) {
      let baseUrl = "http://47.108.13.132:8102";
      if (window.location.host.indexOf("local") != -1) {
        baseUrl = "https://uat01-aimarket.iccec.cn";
      } else if (window.location.host.indexOf("test01") != -1) {
        baseUrl = "https://uat01-aimarket.iccec.cn";
      } else if (window.location.host.indexOf("uat01") != -1) {
        baseUrl = "https://uat01-aimarket.iccec.cn";
      } else {
        baseUrl = "https://aimarket.iccec.cn";
      }
      this.dialogScore = true;
      if (row.pingshenxiangmu == "汇总得分") {
        this.scoreUrl =
          baseUrl +
          "/front/supplyChain/summaryResults?taskId=" +
          row.taskId +
          "&editable=false&step=1&token=" +
          sessionStorage.getItem("AItoken") +
          "&tech=false&bidSubCompanyCode=" +
          prop.substring(8) +
          "&expertId=" +
          JSON.parse(sessionStorage.getItem("expertSourceData")).joinExpertId +
          "&scoreShowType=expert";
      } else {
        this.scoreUrl =
          baseUrl +
          "/front/supplyChain/summaryResults?taskId=" +
          row.taskId +
          "&editable=false&step=1&token=" +
          sessionStorage.getItem("AItoken") +
          "&tech=" +
          (row.pingshenxiangmu == "技术" ? true : false) +
          "&bidSubCompanyCode=" +
          prop.substring(7) +
          "&scoringItemId=" +
          row.originProp.substring(8);
      }
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 使用当前激活的标签页索引
      const currentIndex =
        parseInt(this.active) - 1 < 0 ? 0 : parseInt(this.active) - 1;

      // 只合并第一列（评审项目）
      if (
        columnIndex === 0 &&
        rowIndex != this.transposedListData[currentIndex].list.length - 1 &&
        rowIndex != this.transposedListData[currentIndex].list.length - 2
      ) {
        // 计算相同评审项目出现的次数
        const rowspan = this.getRowspanForActiveTab(
          row.pingshenxiangmu,
          rowIndex,
          currentIndex
        );
        if (rowspan.rowspan === 0) {
          return { rowspan: 0, colspan: 0 };
        }
        return {
          rowspan: rowspan.rowspan,
          colspan: 1
        };
      } else if (
        rowIndex == this.transposedListData[currentIndex].list.length - 1 ||
        rowIndex == this.transposedListData[currentIndex].list.length - 2
      ) {
        if (columnIndex === 0) {
          return [1, 4];
        } else if (
          columnIndex === 1 ||
          columnIndex === 2 ||
          columnIndex === 3
        ) {
          return [0, 0];
        }
      }
    },

    // 修改 getRowspan 方法，接受 tab 索引参数
    getRowspanForActiveTab(department, currentIndex, tabIndex) {
      let rowspan = 1;
      let startIndex = currentIndex;

      // 向前查找相同的评审项目
      for (let i = currentIndex - 1; i >= 0; i--) {
        if (
          this.transposedListData[tabIndex].list[i].pingshenxiangmu ===
          department
        ) {
          rowspan++;
          startIndex = i;
        } else {
          break;
        }
      }

      // 向后查找相同的评审项目
      for (
        let i = currentIndex + 1;
        i < this.transposedListData[tabIndex].list.length;
        i++
      ) {
        if (
          this.transposedListData[tabIndex].list[i].pingshenxiangmu ===
          department
        ) {
          rowspan++;
        } else {
          break;
        }
      }

      // 如果不是相同单元格组的第一个，返回0
      if (currentIndex !== startIndex) {
        return { rowspan: 0, colspan: 0 };
      }

      return { rowspan, colspan: 1 };
    },

    // objectSpanMethod({ row, column, rowIndex, columnIndex }, index) {
    //   // 只合并第一列（部门）
    //   if (
    //     columnIndex === 0 &&
    //     rowIndex != this.transposedListData[index].list.length - 1 &&
    //     rowIndex != this.transposedListData[index].list.length - 2
    //   ) {
    //     // 计算相同部门出现的次数
    //     const rowspan = this.getRowspan(row.pingshenxiangmu, rowIndex);
    //     if (rowspan.rowspan === 0) {
    //       return { rowspan: 0, colspan: 0 };
    //     }
    //     return {
    //       rowspan: rowspan.rowspan,
    //       colspan: 1
    //     };
    //   } else if (
    //     rowIndex == this.transposedListData[index].list.length - 1 ||
    //     rowIndex == this.transposedListData[index].list.length - 2
    //   ) {
    //     if (columnIndex === 0) {
    //       return [1, 4];
    //     } else if (
    //       columnIndex === 1 ||
    //       columnIndex === 2 ||
    //       columnIndex === 3
    //     ) {
    //       return [0, 0];
    //     }
    //   }
    // },

    getRowspan(department, currentIndex) {
      let rowspan = 1;
      let startIndex = currentIndex;

      // 向前查找相同的部门
      for (let i = currentIndex - 1; i >= 0; i--) {
        if (this.transposedListData[0].list[i].pingshenxiangmu === department) {
          rowspan++;
          startIndex = i;
        } else {
          break;
        }
      }

      // 向后查找相同的部门
      for (
        let i = currentIndex + 1;
        i < this.transposedListData[0].list.length;
        i++
      ) {
        if (this.transposedListData[0].list[i].pingshenxiangmu === department) {
          rowspan++;
        } else {
          break;
        }
      }

      // 如果不是相同单元格组的第一个，返回0
      if (currentIndex !== startIndex) {
        return { rowspan: 0, colspan: 0 };
      }

      return { rowspan, colspan: 1 };
    },

    init() {
      this.getData();
      this.reload();
    },
    getSupPersonnelRelationWarning() {
      let param = {
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        step: "6",
        languageFlag: ""
      };
      bidSupPersonnelRelationWarning(param).then(res => {
        if (res.data.code == "0") {
          this.relationWarningList = res.data.data.compareResult;
        }
      });
    },
    getData() {
      qryBidEvaProcessStatusApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId,
        purStep: this.$router.history.current.query.menuKey
      }).then(res => {
        this.labelShow = false;
        this.billStatus = res.data.data.billStatus;
        this.labelType = this.billStatus === "0" ? "score" : "ScoreComplete";
        sessionStorage.setItem(
          "bidEvaProcessStatus",
          JSON.stringify(res.data.data)
        );
        this.$set(
          this.breadcrumbData,
          "status",
          JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
            .billStatusName
        );
        this.labelShow = true;
      });
      let param = {
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId
      };
      if (!this.skillAndCommon) {
        param.scoreItem = "1";
      }
      qryExpertScorePackListApi(param).then(res => {
        this.subPackageFlag = res.data.data.subPackageFlag;
        let arr = [];
        // subPackageFlag: false 不分包
        if (res.data.data.subPackageFlag) {
          res.data.data.notScorePack.forEach(item => {
            // 看是否流标 packStatus 1正常5流标
            if (item.packStatus == "1") {
              if (this.skillAndCommon) {
                arr.push(
                  this.qryExpertSupPackQuoteToScore(item.packId, item.packName)
                );
              } else {
                arr.push(
                  this.qryExpertSupPackQuoteToScore(
                    item.packId,
                    item.packName,
                    "1"
                  )
                );
              }
            }
          });
          res.data.data.hasScorePack.forEach(item => {
            // 看是否流标 packStatus 1正常5流标
            if (item.packStatus == "1") {
              if (this.skillAndCommon) {
                arr.push(
                  this.qryExpertSupPackQuoteScore(item.packId, item.packName)
                );
              } else {
                arr.push(
                  this.qryExpertSupPackQuoteScore(
                    item.packId,
                    item.packName,
                    "1"
                  )
                );
              }
            }
          });
        } else {
          // 不分包 scoreFlag：true 已评分
          if (res.data.data.scoreFlag) {
            if (this.skillAndCommon) {
              arr.push(this.qryExpertSupPackQuoteScore("", ""));
            } else {
              arr.push(this.qryExpertSupPackQuoteScore("", "", "1"));
            }
          }
        }
        Promise.all(arr).then(res => {
          res.forEach(rItem => {
            rItem.columns = JSON.parse(JSON.stringify(this.columns));
            if (this.skillAndCommon) {
              if (this.purchaseType == "50" || this.purchaseType == "53") {
                rItem.columns.splice(6, 0, {
                  prop: "sscSkillScoreItemBOS",
                  label: "技术",
                  labelChild: [],
                  align: "center"
                });
              } else {
                rItem.columns.splice(7, 0, {
                  prop: "sscSkillScoreItemBOS",
                  label: "技术",
                  labelChild: [],
                  align: "center"
                });
              }
            }
            let labelChild = [];
            let labelSkillChild = [];
            console.log(rItem, "rItem");
            rItem.list.forEach((item, index) => {
              item.id = index + 1;
              item.sscScoreBOS.forEach(aItem => {
                aItem.sscScoreItemBOS.forEach(bItem => {
                  item.scoringItemId = bItem.scoringItemId;
                  item.scoreRule = bItem.scoreRule;
                  item.scoreWeight = bItem.scoreWeight;
                  let props = "supScore" + bItem.scoreItemId;
                  item[props] = bItem.supScore;
                  item[props + "aiScore"] = bItem.aiScore
                    ? new BigNumber(bItem.aiScore).toFormat(2)
                    : bItem.aiScore;

                  // 细则权重
                  let scoreWeightProps =
                    "maxScoreWeight-" +
                    aItem.scoreItem +
                    "-" +
                    bItem.scoreRule +
                    "-" +
                    bItem.scoreItemId;
                  item[scoreWeightProps] = bItem.scoreWeight;
                  if (this.skillAndCommon) {
                    if (aItem.scoreItem === "0") {
                      if (
                        labelSkillChild.filter(item => {
                          return item.prop == "supScore" + bItem.scoreItemId;
                        }).length == 0
                      ) {
                        labelSkillChild.push({
                          prop: props,
                          label: bItem.scoreRule,
                          width: 280,
                          labelChild: [
                            {
                              prop: props,
                              label: "细则权重:" + bItem.scoreWeight,
                              width: 280,

                              money: true,
                              labelChild: [
                                {
                                  prop: props,
                                  label: bItem.scoreStandard,
                                  width: 150
                                }
                              ]
                            }
                            // {
                            //   prop: props,
                            //       label: "细则权重:" + bItem.scoreWeight,
                            //       width: 120
                            // }
                          ]
                        });
                      }
                    }
                  }
                  if (aItem.scoreItem === "1") {
                    if (
                      labelChild.filter(item => {
                        return item.prop == "supScore" + bItem.scoreItemId;
                      }).length == 0
                    ) {
                      labelChild.push({
                        prop: props,
                        label: bItem.scoreRule,
                        width: 280,
                        labelChild: [
                          {
                            prop: props,
                            label: "细则权重:" + bItem.scoreWeight,
                            width: 280,

                            money: true,
                            labelChild: [
                              {
                                prop: props,
                                label: bItem.scoreStandard,
                                width: 150
                              }
                            ]
                          }
                          // {
                          //   prop: props,
                          //       label: "细则权重:" + bItem.scoreWeight,
                          //       width: 120
                          // }
                        ]
                      });
                    }
                  }
                });
              });
            });
            if (this.purchaseType == "50" || this.purchaseType == "53") {
              if (labelChild.length + labelSkillChild.length < 3) {
                if (this.skillAndCommon) {
                  delete rItem.columns[9].width;
                } else {
                  delete rItem.columns[8].width;
                }
              }

              if (this.skillAndCommon) {
                rItem.columns[7].labelChild = labelChild;
                rItem.columns[6].labelChild = labelSkillChild;
              } else {
                rItem.columns[6].labelChild = labelChild;
              }
            } else {
              if (labelChild.length + labelSkillChild.length < 3) {
                if (this.skillAndCommon) {
                  delete rItem.columns[10].width;
                } else {
                  delete rItem.columns[9].width;
                }
              }

              if (this.skillAndCommon) {
                rItem.columns[8].labelChild = labelChild;
                rItem.columns[7].labelChild = labelSkillChild;
              } else {
                rItem.columns[7].labelChild = labelChild;
              }
            }
          });
          // 通过包件id进行排序
          res.sort(function(a, b) {
            if (a.packId > b.packId) {
              return 1;
            } else if (a.packId < b.packId) {
              return -1;
            } else {
              return 0;
            }
          });
          this.listData = res;
          console.log(this.columns, "columns");
          console.log(this.listData, "listData");
        });
      });
    },
    // 专家供应商报价待评分列表查询
    qryExpertSupPackQuoteToScore(packId, packName, scoreItem) {
      return new Promise((resolve, reject) => {
        let param = {
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          packId: packId
        };
        if (!this.skillAndCommon) {
          param.scoreItem = scoreItem;
        }
        qryExpertSupPackQuoteToScoreApi(param).then(res => {
          let obj = {
            packId: packId,
            packName: packName ? packName : "不分包",
            hasScore: false, // 是否评分
            list: [],
            headers: [],
            skiiHeaders: []
          };
          if (res.data.data && res.data.data.length > 0) {
            // res.data.data.forEach(item => {
            //   item.sscScoreBOS.forEach(sscScoreBOItem => {
            //     // 将评分项排序保证每条数据对应正确
            //     sscScoreBOItem.sscScoreItemBOS.sort(function(a, b) {
            //       return a.scoreItemId - b.scoreItemId;
            //     });
            //   });
            // });
            // obj.list = res.data.data;
            let flag = true;
            let skiiFlag = true;
            res.data.data[0].sscScoreBOS.forEach(item => {
              if (flag) {
                if (item.scoreItem === "1") {
                  flag = false;
                  obj.headers = Object.assign([], item.sscScoreItemBOS);
                }
              }
              if (this.skillAndCommon) {
                if (skiiFlag) {
                  if (item.scoreItem === "0") {
                    skiiFlag = false;
                    obj.skiiHeaders = Object.assign([], item.sscScoreItemBOS);
                  }
                }
              }
            });
          }
          resolve(obj);
        });
      });
    },
    // 专家供应商报价评分列表查询
    qryExpertSupPackQuoteScore(packId, packName, scoreItem) {
      return new Promise((resolve, reject) => {
        let param = {
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          packId: packId,
          joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .joinExpertId
        };
        if (!this.skillAndCommon) {
          param.scoreItem = scoreItem;
        }
        qryExpertSupPackQuoteScoreApi(param).then(res => {
          let obj = {
            packId: packId,
            packName: packName ? packName : "不分包",
            hasScore: true, // 是否评分
            list: [],
            headers: [],
            skiiHeaders: []
          };
          if (res.data.data && res.data.data.length > 0) {
            res.data.data.forEach(aItem => {
              aItem.supScore = aItem.supScore
                ? new BigNumber(aItem.supScore).toFormat(2)
                : aItem.supScore;
              aItem.sscScoreBOS = aItem.sscSupScoreBOS;
              aItem.sscSupScoreBOS.forEach(bItem => {
                bItem.sscScoreItemBOS = bItem.sscSupScoreItemBOS;
                // 将评分项排序保证每条数据对应正确
                // bItem.sscScoreItemBOS.sort(function(a, b) {
                //   return a.scoreItemId - b.scoreItemId;
                // });
                bItem.sscSupScoreItemBOS.forEach(o => {
                  o.supScore = o.supScore
                    ? new BigNumber(o.supScore).toFormat(2)
                    : o.supScore;
                });
              });
            });
            obj.list = res.data.data;
            let flag = true;
            let skiiFlag = true;
            res.data.data[0].sscScoreBOS.forEach(item => {
              if (flag) {
                if (item.scoreItem === "1") {
                  flag = false;
                  obj.headers = Object.assign([], item.sscScoreItemBOS);
                }
              }
              if (this.skillAndCommon) {
                if (skiiFlag) {
                  if (item.scoreItem === "0") {
                    skiiFlag = false;
                    obj.skiiHeaders = Object.assign([], item.sscScoreItemBOS);
                  }
                }
              }
            });
          }
          resolve(obj);
        });
      });
    },
    viewBidFile(row) {
      this.formData.supPackQuoteId = row.supPackQuoteId;
      this.formData.supQuoteId = row.supQuoteId;
      this.formData.supCode = row.supCode;
      this.dialogVisible = true;
    },
    addOrEdit(item, type) {
      console.log(this.active);
      // type 0:新增 1：编辑
      this.$router.push({
        name: "addCommercialGradeWZ",
        query: {
          type: type,
          skillAndCommon: this.skillAndCommon,
          packId: item.packId,
          menuKey: this.$router.history.current.query.menuKey,
          evaPurStep: this.$router.history.current.query.evaPurStep,
          active: this.active
        }
      });
    },
    dealExpertSupScoreSubmit() {
      this.$confirm(
        "您确定要提交吗？评分表提交后，此信息将不允许被编辑修改。",
        "提交评分确认",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          customClass: "ccui-message-box-custom"
        }
      )
        .then(() => {
          let param = {
            schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .schemeId,
            joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .joinExpertId
          };
          if (!this.skillAndCommon) {
            param.scoreItem = "1";
          }
          qryExpertScorePackListApi(param).then(res => {
            let noScoreFlag = false; // 是否存在正常的未评分包件
            res.data.data.notScorePack.forEach(item => {
              // 看是否流标 packStatus 1正常5流标
              if (item.packStatus == "1") {
                noScoreFlag = true;
              }
            });
            if (noScoreFlag) {
              this.$message({
                message:
                  "您还有评分未完成的包件，请您对每个包件中的供应商评分完毕后，再提交评分结果，谢谢您的配合！！",
                type: "error",
                duration: 3000,
                showClose: true,
                ccuiCustom: true
              });
              return;
            } else {
              dealExpertSupScoreSubmitApi({
                schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
                  .schemeId,
                joinExpertId: JSON.parse(
                  sessionStorage.getItem("expertSourceData")
                ).joinExpertId,
                scoreType: this.skillAndCommon ? "2" : "1"
              }).then(res => {
                if (res.data.code == "0") {
                  this.init();
                  this.$message({
                    message: "提交成功！",
                    type: "success",
                    duration: 3000,
                    showClose: true,
                    ccuiCustom: true
                  });
                }
              });
            }
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.tips {
  color: red;
  padding: 20px 0 0 20px;
}
.tooltip-header {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
}
.fr {
  float: right;
}
.clear {
  clear: both;
}
.star {
  color: #ff1818;
}
.wd2 {
  width: 20px;
}
.wd6 {
  width: 60px;
}
.wd10 {
  width: 100px;
}
.wd20 {
  width: 200px;
}
/deep/ .el-table tr {
  td,
  th {
    height: 36px !important;
    line-height: 36px !important;
    //padding: 5px 10px !important;
    //box-sizing: border-box !important;
    //text-overflow: ellipsis !importan;
    //white-space: nowrap;
  }
}
/deep/ .el-tabs__customize > .el-tabs__header {
  margin-bottom: 20px !important;
  padding-top: 20px !important;
}
/deep/.el-dialog {
  overflow: hidden;
  margin-top: 0px;
  width: calc(100% - 240px) !important;
  left: 100px !important;
  top: 45px !important;
  .el-dialog__body {
    max-height: calc(100vh - 130px - 94px - 20px) !important;
    height: calc(100vh - 130px - 94px - 20px) !important;
  }
}
/deep/.chakanfen {
  .el-dialog {
    width: calc(100%) !important;
    left: 0px !important;
  }
}
/deep/ .el-table--border {
  th:last-of-type.gutter {
    display: table-cell !important;
    width: 0px !important;
  }
}
.tooltip-header {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  margin: 10px 0;
  line-height: 20px;
}
.ellipsis-lines,
/deep/.cell {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; /* 限制行数为3 */
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 3px;
}
</style>
